// console.log('GLOBAL CUSTOM JS EXECUTING');

var globoTimeout = null;

function reInitGloboSwatches() {
  // console.log('REINIT GLOBO FUNCTION CALLED');

  if (globoTimeout) return;

  globoTimeout = setTimeout(function () {
    globoTimeout = null;

    // console.log('TRYING GLOBO REINIT');

    if (window.globoswatch) {
      // console.log('globoswatch found');

      if (typeof window.globoswatch.render === 'function') {
        window.globoswatch.render();
        // console.log('globoswatch.render() called');
        return;
      }

      if (typeof window.globoswatch.init === 'function') {
        window.globoswatch.init();
        // console.log('globoswatch.init() called');
        return;
      }
    }

    if (window.GloboSwatch) {
      // console.log('GloboSwatch found');
    }

    // console.warn('NO VALID GLOBO INIT FOUND');
  }, 100);
}

var observer = new MutationObserver(function (mutations) {
  // console.log('MUTATION DETECTED', mutations.length);
  reInitGloboSwatches();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// console.log('MUTATION OBSERVER ATTACHED');

